import { Box, CircularProgress } from '@mui/joy';
import type { Ref } from 'react';

import type { LoaderAppearance, LoaderProps } from './Loader.props';
import type { SxProps } from '@mui/joy/styles/types/index';

export const appearanceStyles: Record<LoaderAppearance, SxProps> = {
  inline: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '1.5rem',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 120,
    width: '100%',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 300,
    height: '100%',
    width: '100%',
    padding: 2,
    backgroundColor: 'background.body',
    borderRadius: 'md',
  },
};

const Loader = ({
  variant = 'medium',
  fullHeight = false,
  appearance = 'container',
  ref,
}: LoaderProps & { ref?: Ref<HTMLDivElement> }) => {
  const layout = appearance ? appearanceStyles[appearance] : appearanceStyles.container;

  return (
    <Box
      ref={ref}
      sx={{
        aspectRatio: '1',
        maxHeight: '100%',
        ...(fullHeight && { height: '100%', flexGrow: 1, minHeight: 0 }),
        // appearance styles
        ...layout,

        // override height based on variant when not fullHeight
        ...(variant === 'small' && !fullHeight && { height: '1.5rem' }),
        ...(variant === 'medium' && !fullHeight && { height: '8rem' }),
      }}
    >
      <CircularProgress size={variant === 'small' ? 'sm' : 'md'} />
    </Box>
  );
};

export default Loader;
